import * as mobx from 'mobx';
import * as IoC from 'typescript-ioc';
import { IGlobalStorage } from '../../../../../infrastructure/global-storage';
import { IConnectionDetailsDTO } from '../../../../../api/connections.dao';
import { meetingWebinarRequestDetails } from '../../../../../infrastructure/utils/connections.utils';
import { IScheduledZoomMeetingDetailsDTO } from '../../../../../api/zoom.dao';
import { alertServerError } from '../../../../global/modal/alerts-host/alert-templates';
import { IErrorParsing } from '../../../../../infrastructure/error-parsing';
import { LinkTargetValue } from '../../../../../constants/common.constants';

class TroubleshootModalViewModel {
    @mobx.observable
    public isFormShown = false;
    @mobx.observable
    public isLoading = false;
    @mobx.observable
    private connection: IConnectionDetailsDTO = {};
    @mobx.observable
    public meetingDetails: IScheduledZoomMeetingDetailsDTO = {} as IScheduledZoomMeetingDetailsDTO;

    constructor(
        @IoC.Inject private readonly globalStorage: IGlobalStorage = IoC.Container.get(IGlobalStorage)
    ) {
    }

    private static handleApiException = (e: Error, title: string = 'Error'): void => {
        if (e) alertServerError(title, IoC.Container.get(IErrorParsing).extractMessage(e));
    };

    public get connectionId(): string { return this.connection.connectionId; };
    public get meetingTopic(): string { return this.meetingDetails.topic; };
    public get connectionType(): string { return this.connection.type; };

    @mobx.action
    public setConnection = async (connection: IConnectionDetailsDTO): Promise<void> => {
        try {
            mobx.runInAction(() => {
                this.isLoading = true;
            });
            const zoomDAOHandler = meetingWebinarRequestDetails();
            const meetingDetails = await zoomDAOHandler[connection.type]({
                accountId: this.globalStorage.getEvent().accountId,
                eventId: this.globalStorage.getEvent().eventId,
                meetingId: connection.connectionId
            });
            mobx.runInAction(() => {
                this.connection = connection;
                this.meetingDetails = meetingDetails;
            });
            this.showForm();
        } catch (error) {
            TroubleshootModalViewModel.handleApiException(error);
        } finally {
            mobx.runInAction(() => {
                this.isLoading = false;
            });
        }
    };

    @mobx.action
    public showForm = (): void => {
        this.isFormShown = true;
    };

    @mobx.action
    public hideForm = (): void => {
        this.isFormShown = false;
        this.meetingDetails = {} as IScheduledZoomMeetingDetailsDTO;
        this.connection = {};
    };

    public handleStartMeeting = (url: string): void => {
        window.open(url, LinkTargetValue.BLANK);
    };
}

export default TroubleshootModalViewModel;
